export default __webpack_public_path__ + "static/media/Ellipse 111 (1).4b091806.png";